<template>
  <div class="flex justify-between bg-white br-10 p-3 my-10 items-center">
    <div class="flex flex-col">
      <span class="text-black text-xs font-semibold text-opacity-50 mb-1">My Score</span>
      <span class="text-base font-medium text-black mb-1">{{scoreCard.name}}</span>
      <span class="text-xs font-normal text-black">{{scoreCard.department_name}}</span>
    </div>
    <div class="flex gap-1">
      <span v-for="(scoreCount,index) in score" :key="`score-${index}`" class="text-black text-2xl font-bold count-box w-8 h-14 p-3 flex items-center justify-center">{{scoreCount}}</span>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: {
      scoreCard: {
        type: Object,
        default () {
          return {};
        }
      }
    },
    computed: {
      score() {
        let score = this.scoreCard && this.scoreCard.my_scores ? this.scoreCard.my_scores : 0;
        score = ""+score;
        if(score.length == 1){
          score = '0'+score;
        }
        return score.split("");
      }
    }
  }
</script>
<style type="text/css" scoped>
  .count-box {
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 48.96%, #E6E6E6 51.04%, #FFFFFF 76.56%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    border: 1px solid;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.69), rgba(131, 131, 131, 0.69)) 1;
    border-image-source: linear-gradient(180deg, rgba(209, 209, 209, 0.69) 0%, rgba(255, 255, 255, 0.69) 49.48%, rgba(131, 131, 131, 0.69) 100%);
  }
</style>